import MembershipBreakdownModule from "./membershipBreakdownModule";
import MembershipBreakdownReducer from "./redux/membershipBreakdownReducer";
import MembershipBreakdownSaga from "./redux/membershipBreakdownSaga";

export default {
  Component: MembershipBreakdownModule,
  moduleName: "membershipBreakdown",
  saga: MembershipBreakdownSaga(),
  reducer: MembershipBreakdownReducer
};
